import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Formik, FormikHandlers, FormikProps, useFormikContext } from "formik";
import { Alert, Button, Form } from "react-bootstrap";
import axios from "axios";
import moment from "moment-timezone";
import { FileNameContext } from "../pages/Upload";
import VideoInfoInput from "./VideoInfoInput";
import { capWord, FormValues } from "../utils/types";
import colors from "../utils/colors";
import "./style.css";

const videoInfoList = [
  "camera",
  "date",
  "insight",
  "keywords",
  "location",
  "suburb",
  "name",
  "orientation",
  "postcode",
  // "provider",
  // "sensitivity",
  "street",
  // "thumbnail",
];

const initialValues = {
  camera: "",
  date: "",
  insight: "",
  keywords: "",
  suburb: "",
  name: "",
  orientation: "",
  postcode: "",
  provider: "",
  sensitivity: "",
  street: "",
  thumbnail1: undefined,
  thumbnail2: undefined,
  thumbnail3: undefined,
  submit: false,
  videoURL: "",
  location: "",
};

// interface HTMLInputEvent extends Event {
//   target: HTMLInputElement & EventTarget;
// }
interface VideoFormPropsType {
  setUrl: (state: string) => void;
  uploadImage: FileList | undefined;
}

// Pre-fill the video name with the uploaded filename (minus the timestamp prefix
// the server adds) once an upload completes, unless the user has typed one.
function DefaultName({ fileName }: { fileName: string }) {
  const { values, setFieldValue } = useFormikContext<any>();
  useEffect(() => {
    if (fileName && !values.name) {
      setFieldValue("name", fileName.replace(/^\d+-/, ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileName]);
  return null;
}

function VideoForm(props: VideoFormPropsType) {
  const { uploadImage, setUrl } = props;

  const { fileName, valuesForm, setValuesForm, setShowReview, setUploadImage } =
    useContext(FileNameContext);
  console.log("valuesForm", valuesForm);

  const [thumbNum, setThumbNum] = useState([1]);
  const thumbPlusHandler = () => {
    setThumbNum((current) => [...current, current[current.length - 1] + 1]);
  };
  const thumbMinusHandler = () => {
    let newCurrent = [...thumbNum];
    if (thumbNum.length > 1) {
      newCurrent.pop();
    }

    setThumbNum(newCurrent);
  };

  const resetHandler = (resetForm: () => void) => {
    resetForm();
    setValuesForm({
      camera: "",
      date: "",
      insight: "",
      keywords: "",
      suburb: "",
      name: "",
      orientation: "",
      postcode: "",
      provider: "",
      sensitivity: "",
      street: "",
      // thumbnail1: undefined,
      // thumbnail2: undefined,
      // thumbnail3: undefined,
      submit: false,
      videoURL: "",
      location: "",
    });
  };

  //handle thumbnail images upload
  const fileHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) {
      return;
    }
    // setUploadImage(event.target.files[0]);
    setUploadImage(event.target.files);
  };

  return (
    <div className="videoform">
      <Formik
        initialValues={valuesForm}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            console.log("values", values);
            if (!fileName) {
              setErrors({
                submit:
                  "Please choose a video and wait for the upload to finish before continuing.",
              });
              setSubmitting(false);
              return;
            }
            const videoURL = `${process.env.REACT_APP_SMODS_SLS_VIDEO}/stream?name=${fileName}`;

            setUrl(videoURL);

            const dataForReviewPage = {
              ...values,
              provider: "sls",
              sensitivity: "public",
              orientation: values.orientation,
              videoURL,
            };

            setValuesForm(dataForReviewPage);
            // setValuesSaved(values);
            setShowReview(true);
          } catch (error: any) {
            const message = error.message || "Something went wrong";

            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          handleReset,
          resetForm,
          isSubmitting,
          touched,
          values,
        }) => (
          <Form onSubmit={handleSubmit}>
            <DefaultName fileName={fileName} />
            <Alert className="my-3 text-center" variant="primary">
              <div className="alert-message" style={{ fontSize: "17px" }}>
                <strong>Step 2 : </strong> After video uploaded , fill out the
                video information form
              </div>
            </Alert>
            {errors.submit && (
              <Alert className="my-3" variant="danger">
                <div className="alert-message">{errors.submit}</div>
              </Alert>
            )}

            {videoInfoList.map((each) => {
              return (
                <VideoInfoInput
                  each={each}
                  errors={errors}
                  touched={touched}
                  values={values}
                  handleBlur={handleBlur}
                  handleBlur2={handleBlur}
                  handleChange={handleChange}
                  handleChange2={handleChange}
                />
              );
            })}

            <Form.Group className="mb-3">
              {/* <div>
                <Form.Label>Thumbnails</Form.Label>{" "}
                <button
                  style={{ marginLeft: "15px" }}
                  onClick={thumbPlusHandler}
                  type="button"
                  className="thumb-btn"
                >
                  +
                </button>
                <button
                  style={{ marginLeft: "15px" }}
                  onClick={thumbMinusHandler}
                  type="button"
                  className="thumb-btn"
                >
                  -
                </button>
              </div> */}

              <div className="mb-2">
                <label htmlFor="">Choose pictures as video's thumbnails,</label>
                <input
                  required
                  type="file"
                  multiple
                  name="thumbnail"
                  className="file-upload"
                  // value={uploadImage}
                  accept="image/*"
                  onChange={fileHandleChange}
                  style={{ margin: "10px 0px" }}
                />
                {/* <input
                  type="file"
                  name="thumbnail"
                  className="file-upload"
                  // value={values.thumbnail2}
                  style={{ margin: "10px 0px" }}
                />
                <input
                  type="file"
                  name="thumbnail"
                  className="file-upload"
                  // value={values.thumbnail3}
                  style={{ margin: "10px 0px" }}
                /> */}
              </div>

              {/* <Form.Control
                size="sm"
                type="file"
                name="thumbnail"
                placeholder=""
                value={values.thumbnail}
                isInvalid={Boolean(touched.date && errors.thumbnail)}
                onBlur={handleBlur}
                onChange={handleChange}
              /> */}
              {/* {!!touched.thumbnail && (
                <Form.Control.Feedback type="invalid">
                  {errors.thumbnail}
                </Form.Control.Feedback>
              )} */}
            </Form.Group>

            {/* <div>
              <Form.Check
                type="checkbox"
                id="rememberMe"
                label="Remember me next time"
                defaultChecked
              />
            </div> */}

            <div className="text-center mt-3 mb-3">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}
                className="login-btn"
                style={{ background: colors.SLSsecondary }}
              >
                Review form
              </Button>
              <Button
                type="reset"
                variant="danger"
                size="sm"
                className="login-btn"
                // disabled={isSubmitting}
                style={{ marginLeft: "30px", background: colors.SLSprimary }}
                onClick={() => {
                  console.log("reset now");
                  resetHandler(resetForm);
                  resetForm();
                  handleReset();
                  values = initialValues;
                }}
              >
                Reset
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      {/* <img
        src="http://159.196.157.153:4022/live?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DmPQoGVJ_CsU"
        alt="xxx"
      /> */}
    </div>
  );
}

export default VideoForm;
